export function isValidCarousel({ attributes: { items = [] } }: TContent) {
  return items.length >= 5 && items.length <= 20;
}
